import { fmtMult } from "./calc";

export function AssetSelect({ assets, value, onChange, tid }) {
  return (
    <select className="input-solera" value={value} onChange={(e) => onChange(e.target.value)} data-testid={tid}>
      {assets.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
    </select>
  );
}

export function EntrySelect({ a, value, onChange, tid }) {
  return (
    <select className="input-solera" value={value} onChange={(e) => onChange(e.target.value)} data-testid={tid}>
      {a?.entries.map((e) => <option key={e.id} value={e.id}>{`${e.label} · ${fmtMult(e.multiple)}`}</option>)}
    </select>
  );
}
